import "./index.css"
import "./mobile.css";
import React from 'react';

function ProgramModule({indexNumber, name, left, top, imageSource, functionToAdd,moveFunction,upFunction,downFunction,bodySizing}){
    let isMobile = bodySizing.width < 601;
    const eventHandler = isMobile
    ? { onClick: () => functionToAdd(indexNumber) } // for mobile
    : { onDoubleClick: () => functionToAdd(indexNumber) }; // for non-mobile
    return <div className="program-module"       
    {...eventHandler} // Modified line
    style={{ left: left, top: top}}
    onMouseMove={moveFunction}
    onMouseUp={upFunction}
    onMouseDown={downFunction}
    data-boxindex={indexNumber}
    >
    <img alt="program" className="program-module-image" src={imageSource} data-boxindex={indexNumber}></img>
    <div data-boxindex={indexNumber}>{name}</div>
    </div>    
}


export default ProgramModule